import styled from "styled-components";

export const StyledInput = styled.div``;
export const StyledLabel = styled.label.attrs({ className: "label" })`
  width: ${props => props.width};
  input:not([type="checkbox"]),
  .textarea,
  .select {
    margin-top: 4px;
  }
`;
const InputList = styled.div`
  /* display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start; */
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  grid-gap: 15px;
  line-height: 1;
  margin-bottom: 0.5rem;
  &:first-child {
    margin-top: 0.6rem;
  }
  &:last-child {
    margin-bottom: 0.6rem;
  }
  label {
    white-space: nowrap;
    font-size: 11px;
    font-weight: 400;
  }
  .field {
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
  .control {
    width: 100%;
  }
  /* // .expand {
  //   grid-row: 1 / 2;
  //   &:nth-child(1) {
  //     grid-column: 1 / 5;
  //   }
  //   &:nth-child(2) {
  //     grid-column: 5 / 9;
  //   }
  // }
  // .expand:nth-child(1) {
  // } */
  ${StyledLabel} {
    font-size: 10px;
    margin: 0;
    span {
      font-weight: 400;
    }
  }
  ${StyledInput} {
    /* margin-top: 0.5rem;
    &:not(:last-child) {
      margin-right: 10px;
    } */
    input,
    .select {
      height: 2.25em;
    }
  }
  /* 
  //PROFILE SECTION

  .Address1 {
    grid-column: 2 / span 1;
  }
  .ZipCode {
    // grid-column: 1;
    grid-column: 2 / span 1;
  }
  .HomePhoneNo {
    grid-column: 2;
  }
  .AlternatePhoneNo {
    grid-column: 2;
  }
  .EmergencyContact {
    grid-row: 6 / 7;
    grid-column: 2;
  }
  .EmergencyRelationship {
    grid-row: 6 / 7;
    grid-column: 3;
  }
  .EmergencyPhoneNo {
    grid-row: 6 / 7;
    grid-column: 4;
  }
  .Ethnicity {
    grid-row: 7 / 8;
    grid-column: 2;
  }
  .EthnicityOld {
    grid-row: 7 / 8;
    grid-column: 3;
  }
  .Veteran {
    grid-row: 7 / 8;
    grid-column: 4;
  }

  //PAYROLL SECTION

  .BirthDate {
    grid-row: 1 / 2;
    grid-column: 2;
  }
  .SocialSecurityNo {
    grid-row: 1 / 2;
    grid-column: 3;
  }
  .JobTitle {
    grid-row: 1 / 2;
    grid-column: 4;
  }
  .Supervisor {
    grid-row: 1 / 2;
    grid-column: 5;
  }
  .PayrollNote {
    grid-row: 2 / 4;
    grid-column: 1;
  }
  .EmployeeType {
    grid-row: 2 / 3;
    grid-column: 2;
  }

  //VACATION SECTION

  .VacationDaysAllowedThisYear {
    grid-row: 1 / 2;
    grid-column: 2;
  }
  .VacationDaysUsedThisYear {
    grid-row: 1 / 2;
    grid-column: 3;
  }
  .VacationDaysBalance {
    grid-row: 1 / 2;
    grid-column: 4;
  }
  .VacationDaysRenewalDate {
    grid-row: 1 / 2;
    grid-column: 5;
  }
  .PersonalDaysAllowedThisYear {
    grid-row: 2 / 3;
    grid-column: 2;
  }
  .PersonalDaysUsedThisYear {
    grid-row: 2 / 3;
    grid-column: 3;
  }
  .PersonalDaysBalance {
    grid-row: 2 / 3;
    grid-column: 4;
  }
  .PersonalDaysRenewalDate {
    grid-row: 2 / 3;
    grid-column: 5;
  }

  //DRIVER INFO SECTION

  .HomeCompanyLocationId {
    grid-row: 1 / 2;
    grid-column: 1;
  }
  .DriverFlag {
    grid-row: 2 / 3;
    grid-column: 2;
  }
  .DrugTest {
    grid-row: 2 / 3;
    grid-column: 3;
  } */
`;

export default InputList;
